var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishPoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.01922V7.51603V10.5122V13.5083C7 13.5083 8.88851 12.4987 10.1818 12.4987C11.4751 12.4987 12.0711 13.4605 13.3636 13.5083C14.8275 13.5624 17 12.4987 17 12.4987V10.5122V7.51603V4.00956C17 4.00956 14.8283 5.01922 13.3636 5.01922C11.899 5.01922 11.1876 3.885 9.72727 4.00956C8.60681 4.10513 7 5.01922 7 5.01922Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20V13.5083M7 13.5083V10.5122V7.51603V5.01922C7 5.01922 8.60681 4.10513 9.72727 4.00956C11.1876 3.885 11.899 5.01922 13.3636 5.01922C14.8283 5.01922 17 4.00956 17 4.00956V7.51603V10.5122V12.4987C17 12.4987 14.8275 13.5624 13.3636 13.5083C12.0711 13.4605 11.4751 12.4987 10.1818 12.4987C8.88851 12.4987 7 13.5083 7 13.5083Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishPoint);
export default __webpack_public_path__ + "static/media/finish-point.99864e07842b09550481b923dfde8665.svg";
export { ForwardRef as ReactComponent };